import {EventEmitter, Output} from '@angular/core';

export class FilterAbstractModel {

  optionSelected: any;

  @Output() dataFiltered = new EventEmitter<any>();

  public getElementSelected(): void {
    this.dataFiltered.emit(this.optionSelected);
  }

  public compareObjects(o1: any, o2: any) {
    if (o2 === undefined || o2 ===  null) {
      return false;
    }
    return o1.id === o2.id;
  }

  public reset() {
    this.optionSelected = null;
  }
}
